module.exports = __webpack_public_path__ + "static/img/news58_5.1be0b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news58/news58_5.png
// module id = OQHh
// module chunks = 0